module.exports = __webpack_public_path__ + "static/img/200101.fec78918.png";